import {
    AuthenticationQueryParams,
    parseAuthenticationQueryParams
} from '@dtos/query-params';
import AuthenticationParamsStore, { IAuthenticationParamsStore } from '@stores/authentication/authentication-params-store';
import * as React from 'react';

export const authenticationParamsContext = React.createContext<IAuthenticationParamsStore | null>(null);

interface ProviderProps {
    query: string;
}

interface ProviderState {
    store: IAuthenticationParamsStore;
}

export function determineIfQueryParametersAreNew(queryParams: AuthenticationQueryParams, state: ProviderState): boolean {
    if (!queryParams.authorizedRepresentativeId || !queryParams.candidateFirstName || !queryParams.candidateLastName) {
        return false;
    }

    return (
        queryParams.authorizedRepresentativeId !== state.store.authorizedRepresentativeId ||
        queryParams.candidateFirstName !== state.store.candidateFirstName ||
        queryParams.candidateLastName !== state.store.candidateLastName
    );
}

export class AuthenticationParamsProvider extends React.Component<ProviderProps, ProviderState> {
    state = {
        store: new AuthenticationParamsStore()
    };

    static getDerivedStateFromProps(props: ProviderProps, state: ProviderState) {
        const queryParams = parseAuthenticationQueryParams(props.query);
        const isNewQueryParams = determineIfQueryParametersAreNew(queryParams, state);

        if (isNewQueryParams) {
            // not creating a new instance as the observable properties would not track the update
            state.store.setParams(queryParams);

            return {
                store: state.store
            };
        }

        return null;
    }

    constructor(props: ProviderProps) {
        super(props);

        const store = new AuthenticationParamsStore();
        const queryParams = parseAuthenticationQueryParams(props.query);
        store.setParams(queryParams);

        this.state = {
            store
        };
    }

    render() {
        return (
            <authenticationParamsContext.Provider value={this.state.store}>
                {this.props.children}
            </authenticationParamsContext.Provider>
        );
    }
}

export const useAuthenticationParams = () => React.useContext(authenticationParamsContext);



// WEBPACK FOOTER //
// ./src/stores/authentication/authentication-params-context.tsx